import React from 'react';

import { Input, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const TextField = (props) => {
  const {
    required,
    label,
    children,
    helperText,
    wrapClass,
    help,
    ...textFieldProps
  } = props;

  const getComponent = () => {
    if (children) {
      return React.cloneElement(children, { ...textFieldProps });
    }

    return <Input {...textFieldProps} />;
  };
  return (
    <div className={'field-block ' + wrapClass}>
      {label && (
        <div className="text-field-label">
          <label className="text-field-label__name">{label}</label>
          {required && <span className="text-field-label__required">*</span>}
          {help && (
            <Tooltip title={help}>
              <span className="text-field-label__help">
                <QuestionCircleOutlined />
              </span>
            </Tooltip>
          )}
        </div>
      )}
      {getComponent()}
      {helperText && (
        <div className="text-field-error" title={helperText}>
          {helperText}
        </div>
      )}
    </div>
  );
};

export default React.memo(TextField);
